import { API_METHOD, apiRequest } from '../utils/apiClient';

export const fetchCalendarCategories = (token) => apiRequest(API_METHOD.GET, `/calendar/categories`, token);
export const fetchCalendarPmas = (token) => apiRequest(API_METHOD.GET, `/pma/all`, token);
export const fetchCalendarMembers = (token, pmaId) =>
  apiRequest(API_METHOD.GET, `/pma/hacs?pmaId=${encodeURIComponent(pmaId)}`, token);

export const fetchCalendarEvents = (token, startDate, endDate) =>
  apiRequest(
    API_METHOD.GET,
    `/calendar/events?scope=area&start_date=${encodeURIComponent(startDate)}&end_date=${encodeURIComponent(endDate)}`,
    token
  );

export const fetchCalendarEvent = (token, eventId) =>
  apiRequest(API_METHOD.GET, `/calendar/event/${encodeURIComponent(eventId)}`, token);

export const saveCalendarEvent = (token, event) => {
  const events = Array.isArray(event) ? event : [event];
  return apiRequest(API_METHOD.POST, '/calendar/event', token, events);
};

export const reassignCalendarEvent = (token, event, ownerId) => {
  if (event?.id === undefined || event?.id === null) {
    return Promise.reject(new Error('A persisted calendar event is required to reassign it'));
  }

  const normalizedOwnerIds = (Array.isArray(ownerId) ? ownerId : [ownerId])
    .map((id) => String(id ?? '').trim())
    .filter(Boolean);

  if (normalizedOwnerIds.length !== 1) {
    return Promise.reject(new Error('A single new calendar event owner is required'));
  }

  return saveCalendarEvent(token, {
    ...event,
    owner: normalizedOwnerIds,
  });
};

export const deleteCalendarEvent = (token, eventId) =>
  apiRequest(API_METHOD.DELETE, `/calendar/event/${encodeURIComponent(eventId)}`, token);
